<template>
  <el-row :span="24" class="personalizations">
    <el-col :span="24">
      <div class="title">Available Personalizations</div>
      <div class="links">
        First Name (with fallback greeting)
        <a href="#" @click.prevent="copyText('[%first_name | there%]')">Copy</a>
      </div>
      <div class="links">
        Last Name
        <a href="#" @click.prevent="copyText('[%last_name%]')">Copy</a>
      </div>
    </el-col>
  </el-row>
</template>
<script>
  export default {
    methods: {
      copyText(string) {
        this.$copyText(string).then(() => {
          this.$message.success('Copied!');
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .personalizations {
    width: 30%;
  }

  .title {
    font-weight: 700;
    font-size: .875rem;
  }

  .links {
    line-height: 1.5;
    display: flex;
    justify-content: space-between;
    font-size: .75rem;
  }

  .links a {
    font-size: .75rem;
    color: #00152a;
    text-decoration: underline;
  }
</style>
